import * as React from "react";
import { LinkOutlined } from "@ant-design/icons";

export interface ExternalLinkButtonProps {
  onClick: () => void;
  label: string;
}
export const ExternalLinkButton: React.FC<ExternalLinkButtonProps> = ({ onClick, label }) => {
  return (
    <div className={`flex items-center`}>
      <button type={"button"} className="truncate color-link ngfocus" onClick={onClick}>
        <span>{label}</span>
        <LinkOutlined className="inline-block ml-1" />
      </button>
    </div>
  );
};
